import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M2.5 3.9a.6.6 0 0 0 0 1.2h19a.6.6 0 1 0 0-1.2h-19Zm10.1 5.6a.6.6 0 1 0-1.2 0v8.552l-3.976-3.976a.6.6 0 1 0-.848.848l5 5a.6.6 0 0 0 .848 0l5-5a.6.6 0 1 0-.848-.848L12.6 18.052V9.5Z"
    />
  </svg>
`;
